import { render, staticRenderFns } from "./MiuTagGroup.vue?vue&type=template&id=b4c25432&scoped=true"
import script from "./MiuTagGroup.vue?vue&type=script&lang=js"
export * from "./MiuTagGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c25432",
  null
  
)

export default component.exports